import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    minHeight: 'calc(100vh - 128px)',

    [theme.breakpoints.up('xl')]: {
      width: (p) => (p.isModal ? undefined : '100%'),
    },

    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },

    '& .MuiTab-labelIcon': {
      minHeight: 50,
    },
  },
  tab: {
    backgroundColor: theme.palette.primary.dark,

    '& .MuiTab-wrapper': {
      flexDirection: 'row',
    },
    '& .MuiTab-wrapper > *:first-child': {
      marginBottom: 0,
      marginRight: theme.spacing(1),
    },
  },
  content: {
    maxWidth: theme.breakpoints.values['lg'],
    margin: 'auto',
    textAlign: 'left',
    marginBottom: theme.spacing(2),
  },
}));

export default useStyles;
